import React from "react";
import "../styles/files.css";
import angel from "../img/angel.png";

function Files() {
  return (
    <div className="files">
      <div className="borders files__border">
        <div className="files__container">
          <div className="files__title">
            <span>D</span>OSYALAR
          </div>
          <div className="files_itemContainer">
            <div className="files__item">
              <a
                target="_blank"
                href={`${process.env.REACT_APP_DOWNLOAD_1_LINK}`}
              >
                {process.env.REACT_APP_DOWNLOAD_1_NAME}
              </a>
            </div>
            <div className="files__item">
              <a
                target="_blank"
                href={`${process.env.REACT_APP_DOWNLOAD_2_LINK}`}
              >
                {process.env.REACT_APP_DOWNLOAD_2_NAME}
              </a>
            </div>
          </div>

          <img className="imgAngel" src={angel} alt="" angel />
        </div>
        <div className="topLeftBorder">
          <div>
            <div className="borderTop"></div>
            <div className="borderLeft"></div>
          </div>
        </div>
        <div className="bottomRigtBorder">
          <div>
            <div className="borderRight"></div>
            <div className="borderBottom"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Files;
